var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('language-inputs',{attrs:{"errors":_vm.languageErrors},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})}
var staticRenderFns = []

export { render, staticRenderFns }